import React from "react";

import BaseButton from "./BaseButton/BaseButton";

function formatCooldown(seconds) {
    const minutes = String(Math.floor(seconds / 60)).padStart(2, "0");
    const remainingSeconds = String(seconds % 60).padStart(2, "0");

    return `${minutes}:${remainingSeconds}`;
}

export default function CodeWriter({
    code,
    info,
    resendCooldown,
    onCodeChange,
    onBack,
    onResend,
    disabled = false,
}) {
    const isResendDisabled = disabled || resendCooldown > 0;

    return (
        <form className="flex-col gap1" onSubmit={(event) => event.preventDefault()}>
            {info ? (
                <div className="grey" style={{ fontSize: 14, lineHeight: 1.45, whiteSpace: "pre-line" }}>
                    {info}
                    <span className="giperssilka" onClick={onBack}>{" "}изменить почту</span>
                </div>
            ) : null}

            <div className="flex-col gap05">
                <label htmlFor="code" style={{ color: "var(--color-text-white)" }}>
                    <strong>Введите код подтверждения</strong>
                </label>
                <input
                    className="w100 font11 txt_rob inp"
                    type="text"
                    id="code"
                    name="code"
                    value={code}
                    onChange={(event) => onCodeChange(event.target.value.replace(/\D/g, "").slice(0, 6))}
                    placeholder="6 цифр"
                    inputMode="numeric"
                    disabled={disabled}
                    required
                />
            </div>

            <div className="flex-center gap1" style={{ justifyContent: "space-between" }}>
                <BaseButton
                    onClick={onResend}
                    disabled={isResendDisabled}
                    className="w100"
                    showArrow={false}
                    contentAlign="center"
                >
                    <span>
                        {resendCooldown > 0
                            ? `Отправить код повторно (${formatCooldown(resendCooldown)})`
                            : "Отправить код повторно"}
                    </span>
                </BaseButton>
            </div>
        </form>
    );
}
